import { MessageSquare, PenLine } from "lucide-react";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";

const TEMPLATES = [
  "Hi {first}, this is {company}. Thanks for sending your {service} project! Can I stop by Thursday to take a look?",
  "Hi {first}, I got your photos. I'd like to see the space in person. What day works best for a quick visit this week?",
  "Hi {first}, this is {company}. I'm on my way and should be there in about 20 minutes.",
  "Hi {first}, I'm running about 15 minutes late. Sorry about that, see you soon!",
  "Hi {first}, your quote for the {service} project is on its way to your email. Let me know if you have any questions.",
  "Hi {first}, just following up on your {service} project. Are you still interested in moving forward?",
];

const fill = (t, vars) => t.replace(/\{(\w+)\}/g, (_, k) => vars[k] || "");
const smsHref = (tel, body) => `sms:${tel}${body ? `?&body=${encodeURIComponent(body)}` : ""}`;

export const TextTemplates = ({ tel, contact, serviceType, companyName, trigger }) => {
  const vars = { first: contact.name.trim().split(/\s+/)[0], company: companyName, service: serviceType.toLowerCase() };
  return (
    <Drawer>
      <DrawerTrigger asChild>{trigger}</DrawerTrigger>
      <DrawerContent data-testid="text-templates-drawer">
        <DrawerHeader className="text-left">
          <DrawerTitle className="text-xl">Text {vars.first}</DrawerTitle>
          <p className="text-sm text-muted-foreground">Tap a message to open it in your Messages app.</p>
        </DrawerHeader>
        <div className="max-h-[60vh] space-y-2 overflow-y-auto px-4 pb-6" style={{ paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))" }}>
          {TEMPLATES.map((t, i) => (
            <a key={i} href={smsHref(tel, fill(t, vars))} data-testid={`text-template-${i}`}
              className="flex gap-3 rounded-2xl border-2 border-border bg-card p-4 text-[15px] leading-snug text-foreground transition-transform active:scale-[0.98]">
              <MessageSquare className="mt-0.5 h-5 w-5 shrink-0 text-[color:var(--brand)]" />{fill(t, vars)}
            </a>
          ))}
          <a href={smsHref(tel, "")} data-testid="text-template-blank"
            className="flex items-center gap-3 rounded-2xl border-2 border-dashed border-border p-4 text-[15px] font-semibold text-muted-foreground">
            <PenLine className="h-5 w-5" /> Write my own message
          </a>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
